import { createFileRoute } from "@tanstack/react-router";
import { fallback, zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";

import { DocumentTitle } from "@/components";
import { BillingReportListPage } from "@/modules/billing";
import { requireSuperAdmin } from "@/utils";

const billingReportsSearchSchema = z.object({
  q: fallback(z.string(), "").default(""),
  page: fallback(z.number(), 1).default(1)
});

export const Route = createFileRoute("/billing/report/")({
  validateSearch: zodValidator(billingReportsSearchSchema),
  beforeLoad: requireSuperAdmin,
  component: () => (
    <>
      <DocumentTitle
        title="Billing Reports"
        description="View and manage billing reports for Marketplace Partners"
      />
      <BillingReportListPage />
    </>
  )
});
